import { Button } from '@/components/ui/button'
import { useNavigation } from '@/hooks/use-navigation'
import { AlertTriangle, Home, RefreshCw, ArrowLeft } from 'lucide-react'

/**
 * 500 Server Error page with smart navigation
 */
export default function ServerError() {
  const { navigateWithGuards, getDefaultRedirect, navigationState } = useNavigation()

  const handleRefresh = () => {
    window.location.reload()
  }

  const handleGoBack = () => {
    window.history.back()
  }

  const handleGoHome = () => {
    const defaultRoute = getDefaultRedirect()
    navigateWithGuards(defaultRoute)
  }

  return (
    <div className="min-h-screen bg-linen flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="w-20 h-20 bg-error-light rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-10 h-10 text-error" />
        </div>
        
        <h1 className="font-display text-6xl font-bold text-error mb-4">500</h1>
        <h2 className="font-display text-2xl font-bold text-night-900 mb-2">
          Server Error
        </h2>
        <p className="font-body text-night-500 mb-8">
          Something went wrong on our end. Please try refreshing the page or come back later.
        </p>
        
        <div className="space-y-3">
          <Button 
            onClick={handleRefresh}
            className="w-full inline-flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-4 h-4" />
            Refresh Page
          </Button>
          
          <Button 
            onClick={handleGoHome}
            variant="outline" 
            className="w-full inline-flex items-center justify-center gap-2"
          >
            <Home className="w-4 h-4" />
            {navigationState.isAuthenticated ? 'Go to Dashboard' : 'Go to Homepage'}
          </Button>
          
          <Button 
            onClick={handleGoBack}
            variant="ghost" 
            className="w-full inline-flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  )
}